import classNames from 'classnames'
import { ReactNode } from 'react'

import { Translation } from 'cng-common/features/translations'

import styles from './Tag.module.scss'

export type TTagVariant = 'danger' | 'warning' | 'success' | 'info' | 'neutral'

interface ITagProps {
  className?: string
  variant?: TTagVariant
  translation?: string | ReactNode
  shortView?: boolean
  /** Pill keeps the same compact size across all usages. */
  shape?: 'rounded' | 'pill'
  /** Surface treatment for pill tags. */
  appearance?: 'soft' | 'dashed'
  /** Decorative marker matching the tag's appearance. */
  marker?: boolean
}

export const Tag = ({
  variant,
  translation,
  shortView,
  className,
  shape = 'rounded',
  appearance = 'soft',
  marker = false,
}: ITagProps) => {
  if (!translation) {
    return null
  }

  if (shortView && variant) {
    return <div className={classNames(styles.short, styles[`short--${variant}`], className)} />
  }

  return (
    <div
      className={classNames(
        styles.tag,
        variant && styles[`tag--${variant}`],
        shape === 'pill' && styles.pill,
        shape === 'pill' && appearance === 'dashed' && styles.dashed,
        className
      )}
    >
      {marker && <span className={styles.marker} aria-hidden="true" />}
      {typeof translation === 'string' ? <Translation text={translation} /> : translation}
    </div>
  )
}
